<template>
  <div class="footer-container">
    <div class="link-container">
      <div class="module-box">
        <div class="first-title">集团</div>
        <a class="second-title" href="http://www.procaregroup.com/company/">关于我们</a>
        <a class="second-title" href="http://www.procaregroup.com/gaozhifuwu/">产业集群</a>
        <a class="second-title" href="http://www.procaregroup.com/redianzixun/">热点咨询</a>
      </div>
      <div class="module-box">
        <div class="first-title">政策公告</div>
        <a class="second-title" href="http://www.procaregroup.com/jiedu/">政策解读</a>
        <a class="second-title" href="http://www.procaregroup.com/tashanzhishi/">他山之石</a>
        <a class="second-title" href="http://www.procaregroup.com/hangyebiaozhun/">行业标准</a>
      </div>
      <div class="module-box">
        <div class="first-title">大健康行业咨询</div>
        <a class="second-title" href="http://www.procaregroup.com/hangyezix/">关于汇林智库</a>
        <a class="second-title" href="http://www.procaregroup.com/yanjiuyuan/">三大产业研究院</a>
        <a class="second-title" href="http://www.procaregroup.com/zhihuichaoshi/">智慧超市</a>
      </div>
      <div class="module-box">
        <div class="first-title">大健康产业实践</div>
        <a class="second-title" href="http://www.procaregroup.com/dajiankangchanyeshijian/">关于柏瑞康健康</a>
        <a class="second-title" href="http://www.procaregroup.com/xiangmujieshao/">项目介绍</a>
        <a class="second-title" href="http://www.procaregroup.com/hulibiaobing/">护理人风采</a>
        <a class="second-title" href="http://www.procaregroup.com/shenghuoyuandi/">生活园地</a>
      </div>
      <div class="module-box">
        <div class="first-title">大健康人才教育培训</div>
        <router-link :to="{ name: 'courseList' }" class="second-title">课程列表</router-link>
        <router-link :to="{ name: 'onlineExam' }" class="second-title">在线考试</router-link>
        <router-link class="second-title" :to="{ name: 'remoteEducation' }">远程教育</router-link>
        <router-link class="second-title" :to="{ name: 'studyRoom' }">柏瑞康书斋</router-link>
        <router-link class="second-title" :to="{ name: 'schoolShow' }">学校风采</router-link>
        <router-link class="second-title" :to="{ name: 'personalCenter' }">个人中心</router-link>
      </div>
      <div class="module-box">
        <div class="first-title">联系我们</div>
        <div class="second-title">
          公司电话：
          <span>0755-9823654</span>
        </div>
        <div class="second-title">公司地址：深圳市龙岗区天安云谷11栋2401-2402</div>
        <div class="second-title s-title">关注我们：</div>
        <div class="contact-box">
          <div class="c-img-box">
            <img class="c-img" src="@/assets/img/qq.png" alt="QQ" />
          </div>
          <div class="c-img-box">
            <img class="c-img" src="@/assets/img/wx.png" alt="微信" />
            <img class="code-img" src="@/assets/img/wx-code.png" alt="微信" />
          </div>
          <div class="c-img-box">
            <img class="c-img" src="@/assets/img/wb.png" alt="微博" />
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-box">
      <div class="left-box">
        <div class="b-link">企业招聘</div>
        <div class="line"></div>
        <div class="b-link">友情链接</div>
        <div class="line"></div>
        <div class="b-link">联系我们</div>
        <div class="line"></div>
        <div class="b-link">网站地图</div>
      </div>
      <div class="right-box">
        © 2021 Copyright 柏瑞康集团有限公司 All Rights Reserved.
        <a
          target="_blank"
          href="https://beian.miit.gov.cn/"
        >粤ICP备2021037065号</a> 技术支持：
        <a target="_blank" href="http://www.made-in-dongguan.com">中赢科技</a>
      </div>
    </div>
  </div>
</template> 
<script>
export default {
  name: 'footerBox'
};
</script>
<style lang="scss" scoped>
.footer-container {
  padding: 76PX 160PX 42PX;
  color: #ffffff;
  background-color: #333333;
}
@media screen and (max-width: 1400PX) {
  .footer-container {
    padding: 76PX 80PX 42PX;
  }
}
.link-container {
  display: flex;
  justify-content: space-between;
  padding-bottom: 70PX;
  border-bottom: 1PX solid #3b3b3b;
  .module-box:last-child {
    .second-title {
      &:hover {
        color: #939393;
      }
    }
  }
  .first-title {
    padding-bottom: 30PX;
    font-size: 18PX;
  }
  .second-title {
    display: block;
    padding-bottom: 15PX;
    color: #939393;
    cursor: pointer;
    &:hover {
      color: #ffffff;
    }
    span {
      font-size: 30PX;
      color: #f1a373;
    }
  }
  .s-title {
    padding-bottom: 36PX;
  }
  .contact-box {
    display: flex;
    position: relative;
    .code-img {
      display: none;
      position: absolute;
      left: 30PX;
    }
    .c-img-box {
      width: 41PX;
      height: 41PX;
      background: #434343;
      border-radius: 50%;
      margin-right: 20PX;
      cursor: pointer;
      .c-img {
        margin-right: 0;
      }
      &:hover {
        .c-img {
          background: #5e5e5e;
          border-radius: 50%;
        }
        .code-img {
          display: block;
        }
      }
    }
    .c-img {
      margin-right: 20PX;
      cursor: pointer;
      &:hover {
        background: #5e5e5e;
      }
    }
  }
}
.bottom-box {
  display: flex;
  justify-content: space-between;
  padding-top: 28PX;
  .left-box {
    display: flex;
    justify-content: space-between;
    width: 36%;
    color: #939393;
  }
  .b-link {
    cursor: pointer;
    &:hover {
      color: #ffffff;
    }
  }
  .line {
    height: 14PX;
    margin: 4PX 0 0;
    border-left: 1PX dashed #939393;
  }
  .right-box {
    color: #939393;
    a {
      color: #939393;
      &:hover {
        color: #ffffff;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/footerBox.vue